<template>
	<div>
		<div class="row" v-for="(item, index) in movie_subtitles" :id="'SubEdit' + item.id">
		    <div class="col-sm-2">
		    	<input type="text" name="subLabelEditShow[]" :value="item.label_name" class="form-control" readonly>
		    </div>

		    <div class="col-sm-9"> 
		    	<input type="text" :value="item.sub_file" readonly="readonly" class="form-control mb-10">
		    </div>

		    <div class="col-sm-1">
		    	<button type="button" @click.prevent="onDeleteSub(item.id, index)" class="btn btn-danger"><i class="icon-trash"></i></button>
			</div>	
		</div>
	</div>
</template>

<script>
import axios from 'axios'
import lodash from 'lodash'
const token = localStorage.getItem('token')
export default {
  name: 'SubEdit',
  props: ['movie_subtitles'],
  data () {
    return {

    }
  },
  mounted() {
  	let vm = this
  	Ladda.bind('button[type=submit]')
  },
  methods:{
    onDeleteSub(id, index){
    	let vm = this;
		Swal.fire({
	            title: "Are you sure?",
	            text: "You will not be able to recover this Subtitle!",
	            type: "warning",
	            showCancelButton: true,
	            confirmButtonColor: "#FF7043",
	            confirmButtonText: "Yes, delete it!"
		    }).then((result) => {
				  if (result.value) {
					axios.get('movie/delete/sub/'+ id + '?token=' + token)
					.then(function (response) {
					    Ladda.stopAll()
					    vm.movie_subtitles.splice(index, 1)
					    vm.$store.dispatch('loadDataMovie')
					    vm.notify('success_delete')
					})
					.catch(function (error) {
					    Ladda.stopAll()
					    vm.notify('error_delete')
					});
				  }
				});

    }
  	//
  }
}
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/components/child/SubEdit.vue